class scrollFunc {
  constructor(elm){
    this.elm = elm;
  }

  check() {
    let el = this.elm;
    let offsetTop = 0;
    while (el) {
      offsetTop += el.offsetTop;
      el = el.offsetParent;
    }
    const top = offsetTop - window.pageYOffset;

    if ((top - window.innerHeight / 2) < 0) {
      return true;
    }else{
      return false;
    }
  }
}

const scrollr = document.querySelectorAll(".scrollr");
for(let i = 0, len = scrollr.length; i < len; i++){
  const _this = scrollr[i];
  const scrollfunc = new scrollFunc(_this);

  const checkScrollFlag = () => {
    const flag = scrollfunc.check();
    if(flag === true){
      _this.classList.add("active");
      window.removeEventListener("scroll", checkScrollFlag);
    }    
  }
  window.addEventListener("scroll", checkScrollFlag)
}

const easingEaseOutCubic = function (currentTime, startValue, changeValue, duration) {
  currentTime /= duration;
  currentTime--;
  return changeValue * (currentTime * currentTime * currentTime + 1) + startValue;
};

const scrollToAnchor = (ev) => {
  ev.preventDefault();
  document.querySelector('.sp_menu').classList.remove('show');
  const target = document.querySelector(ev.currentTarget.getAttribute('href'));
  let
    time = 0,
    currentScrollTop = window.pageYOffset,
    targetScrollTop = window.pageYOffset + target.getBoundingClientRect().top,
    scrollInterval = () => {
      time += 0.1;
      let ease = easingEaseOutCubic(time, currentScrollTop, targetScrollTop - currentScrollTop, 3) ;
      window.scrollTo(0, ease);
      if(time > 3) return;
      window.requestAnimationFrame(scrollInterval);
    };
  scrollInterval();
}

const anchors = document.querySelectorAll('.easeAnchor');
for(let i = 0, len = anchors.length; i < len; i++){
  anchors[i].addEventListener('click', scrollToAnchor);
}

document.querySelector('.hamburger').addEventListener('click', () => {
  document.querySelector('.sp_menu').classList.toggle('show');
})

window.addEventListener("DOMContentLoaded", () => {
  const mv = document.querySelectorAll(".mv");
  for(let i = 0, len = mv.length; i < len; i++){
    const mv_img = mv[i].querySelector('img').getAttribute("src")
    mv[i].style.backgroundImage = `url( ${mv_img} )`;
    mv[i].style.backgroundSize = "cover";
    mv[i].style.backgroundPosition = "50% 50%";
    mv[i].removeChild(mv[i].querySelector("img"))
  }
});

window.addEventListener('load', () => {
  const link = document.querySelectorAll("a");
  for(let i = 0, len = link.length; i < len; i++){
    const href = link[i].href, hash = href.split('?')[1] || null;
    if(href.indexOf('tachikichi.jp') > 0){
      if(hash === null || hash.indexOf("?from=gallery") === -1){
        link[i].setAttribute("href", href + "?from=gallery")
      }
    }
  }
})